import WidgetUtil from "../utils/WidgetUtil.js";

// Mount order-independently: this bundle can be injected higher in the page than
// the widget mount targets (e.g. the WidgetCalendar in the ReservationBar lower
// on the homepage). Running mountWidgets() synchronously would then miss those
// targets (getElementById returns null) and never retry. So wait for the DOM to
// be parsed before mounting.
if ( document.readyState === "loading" )
{
  document.addEventListener("DOMContentLoaded", () => WidgetUtil.mountWidgets());
}
else
{
  WidgetUtil.mountWidgets();
}
